import RequireAuth from "./requireAuth";
import { Outlet } from "react-router-dom";

export const protectedLayout = (
  <RequireAuth>
    <Outlet />
  </RequireAuth>
);
